export default __webpack_public_path__ + "static/media/qr_downloads.ba57375c.png";